import { Alert, AlertDescription, AlertIcon, type AlertProps } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const EndedContractWinnersAlert = ({ suppliers, ...alertProps }: { suppliers: string[] } & AlertProps) => {
  const { t } = useTranslation();
  if (suppliers.length === 0) return null;
  return (
    <Alert status="warning" rounded="md" fontSize="sm" alignItems="flex-start" {...alertProps}>
      <AlertIcon />
      <AlertDescription>
        {t(
          "{{suppliers}}'s contract under the framework agreement has ended, so the mini-competition can't be awarded to it. Choose another tenderer, or cancel the mini-competition.",
          { suppliers: suppliers.join(", ") },
        )}
      </AlertDescription>
    </Alert>
  );
};
